const HomeBlog = [
    {
        "id": 1,
        "blogName": "Top 10 HTML & CSS Interview Question",
        "blogImg": "https://i.postimg.cc/CxWtQHfz/2.jpg",
        "blogAddress":"https://medium.com/@mdriyaz5965/top-10-html-css-interview-question-44664c62f525",
    },
    {
        "id": 2,
        "blogName": "Command Prompt: 5 basic commands you should know",
        "blogImg": "https://i.postimg.cc/y8JtjrxM/1.png",
        "blogAddress":"https://medium.com/@mdriyaz5965/command-prompt-5-basic-commands-you-should-know-2326cb4645a1",
    },
    {
        "id": 3,
        "blogName": "5 String Prototype In JavaScript.",
        "blogImg": "https://miro.medium.com/max/700/0*mmjrtycjb8wpAzfe",
        "blogAddress":"https://mdriyaz5965.medium.com/5-string-prototype-in-javascript-b7ad8563245b",
    },
    {
        "id": 4,
        "blogName": "Error handling, “try..catch”",
        "blogImg": "https://miro.medium.com/max/700/0*mcEXZHigR9NZxWRa",
        "blogAddress":"https://mdriyaz5965.medium.com/error-handling-try-catch-1e1d1bfe2549",
    },
    {
        "id": 5,
        "blogName": "5 Tips To Optimize Your React Application Performance",
        "blogImg": "https://miro.medium.com/max/700/1*y6C4nSvy2Woe0m7bWEn4BA.png",
        "blogAddress":"https://mdriyaz5965.medium.com/10-tips-to-optimize-your-react-application-performance-b3cc64bd9113",
    },
    {
        "id": 6,
        "blogName": "10 Popular JavaScript Interview Question and Answer",
        "blogImg": "https://miro.medium.com/max/700/0*T8wLM3-3GLI03OVd",
        "blogAddress":"https://mdriyaz5965.medium.com/10-popular-javascript-interview-question-and-answer-e591b3c4b1db",
    },
]
export default HomeBlog;